import { Grid, Typography } from '@mui/material'
import Head from 'next/head'

interface PageWrapperProps {
    pageHeader: string
    children: JSX.Element | JSX.Element[]
    topLeftSlot?: JSX.Element | JSX.Element[]
    topRightSlot?: JSX.Element | JSX.Element[]
    subHeader?: string
    bottomRightSlot?: JSX.Element | JSX.Element[]
}

export const PageWrapper = ({
    pageHeader,
    children,
    topLeftSlot,
    topRightSlot,
    subHeader,
    bottomRightSlot,
}: PageWrapperProps) => {
    return (
        <>
            <Head>
                <title>{pageHeader}</title>
            </Head>
            <Grid container justifyContent="space-between" alignItems="center" marginBottom={'32px'} spacing={'16px'}>
                {(topLeftSlot || topRightSlot) && (
                    <Grid container justifyContent="space-between">
                        <Grid item data-test="page-wrapper-top-left-slot">
                            {topLeftSlot}
                        </Grid>
                        {topRightSlot && (
                            <Grid item data-test="page-wrapper-top-right-slot">
                                {topRightSlot}
                            </Grid>
                        )}
                    </Grid>
                )}
                <Grid item xs={subHeader ? 12 : undefined}>
                    <Typography data-test="page-wrapper-header" variant="h4" sx={{ fontWeight: 'bold' }}>
                        {pageHeader}
                    </Typography>
                </Grid>
                {subHeader && (
                    <Grid item>
                        <Typography data-test="page-wrapper-sub-header" variant="h5" sx={{ fontWeight: 'bold' }}>
                            {subHeader}
                        </Typography>
                    </Grid>
                )}
                <Grid item data-test="page-wrapper-bottom-right-slot">
                    {bottomRightSlot}
                </Grid>
            </Grid>
            {children}
        </>
    )
}
